<template>
    <div class="main-sidebar">
        <div class="menu-container">
            <ul>
                <li v-for="(menuItem, index) in menuItems" :key="`menu_item_${index}`">
                    <div :class="highlightSection(menuItem.name)"
                         @click.prevent="changeSelectedSubMenu(menuItem.name, subMenuItems)"
                         v-if="menuItem.items.length > 0">
                        <b-icon :icon="menuItem.icon"></b-icon>
                        <p>
                            {{ menuItem.name }}
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="context-menu-container" v-if="isSubMenuVisible">
            <div class="submenu-header">
                <p class="submenu-title">{{ activeSubMenuLabel }}</p>
                <div>
                    <b-button
                        class="submenu-close-icon-button"
                        size="is-large"
                        icon-left="close"
                        @click="toggleSubMenuVisible()"></b-button>
                </div>
            </div>
            <div class="submenu-card-container">
                <div v-for="(subMenuItem, index) in activeSubMenu"
                     :key="`submenu-item-${index}`">
                    <div v-if="!subMenuItem.dropdown.is_active">
                        <router-link
                            :to="{name: subMenuItem.route, params: {resource: subMenuItem.resource, action: 'index'}}">
                            <p class="submenu_link" @click="toggleSubMenuVisible()">
                                {{ subMenuItem.label }}
                            </p>
                        </router-link>
                    </div>
                    <div v-else-if="subMenuItem.dropdown.is_active">
                        <div class="card">
                            <header class="card-header">
                                <p class="card-header-title">
                                    {{ subMenuItem.label }}
                                </p>
                            </header>
                            <div class="content">
                                <div v-for="(dropdownOption, index) in subMenuItem.dropdown.options"
                                     :key="`dropdown_option_${index}`">
                                    <router-link
                                        :to="{name: dropdownOption.route, params: {resource: dropdownOption.resource, action: 'index'}}">
                                        <p class="submenu_link" @click="toggleSubMenuVisible()">
                                            {{ dropdownOption.name }}
                                        </p></router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        menuItems: {
            type: Array,
            required: true
        },
        subMenuItems: {
            type: Map,
            required: false
        }
    },
    data() {
        return {
            activeSubMenu: undefined,
            activeSubMenuLabel: undefined,
            isSubMenuVisible: false
        }
    },
    methods: {
        toggleSubMenuVisible() {
            this.isSubMenuVisible = !this.isSubMenuVisible;
        },
        changeSelectedSubMenu(label, subMenuItems) {
            if (!this.isSubMenuVisible && (this.activeSubMenuLabel !== label)) {
                this.toggleSubMenuVisible();
            } else if (this.activeSubMenuLabel === label) {
                this.toggleSubMenuVisible();
            }
            this.activeSubMenuLabel = label;
            this.activeSubMenu = subMenuItems.get(label);
        },
        highlightSection(currentMenuLabel) {
            return {
                'menu_link': true,
                'menu_link--active': this.activeSubMenuLabel === currentMenuLabel,
            };
        },
    },
}
</script>
